import isPlainObject from 'lodash/isPlainObject';
import { runMingo, unFlatten } from '@buddy-technology/ion-helpers';
/**
 * @typedef Values
 * @property {Object} [rawState = {}] - top level form state (flat keys, e.g. `policy::foo`)
 * @property {Object} [variables = {}] - the ion variables in case they're referenced
 * @property {Object} [offeringOptions = {}] - offering options
 * @property {Object} [unflattenedState] - optional pre-unflattened form state. Pass this when calling repeatedly with the same rawState to avoid the per-call unFlatten cost.
 */
/**
 * Helper function for extracting isHidden property from a mingo calculation
 * @param  {Object | Boolean} isHidden - isHidden property
 * @param  {Values} [values={rawState:{},variables:{},offeringOptions:{}}] - state inputs
 * @returns {Boolean}
 */
const calculateIsHidden = (isHidden, {
	rawState = {}, variables = {}, offeringOptions = {}, unflattenedState,
} = {}) => {
	if (typeof isHidden === 'boolean') {
		return isHidden;
	}
	// Short-circuit: nothing to evaluate when isHidden isn't a mingo script.
	// Skipping here avoids an unnecessary unFlatten on the common "no isHidden" case.
	if (!isPlainObject(isHidden)) {
		return Boolean(isHidden);
	}
	const { _calculate: script } = isHidden;
	if (typeof script === 'string') {
		throw new Error('_calculate script is a string. Did you forget to parse the ION?');
	}
	const formState = unflattenedState || unFlatten(rawState);
	const { value: shouldHide } = runMingo(script, { ...formState, variables, offeringOptions }); // if there's an error, shouldHide will be falsy.
	return shouldHide;
};

export default calculateIsHidden;
